import EventBus, { EVENTS } from "@/lib/event-bus"
import { REASONS, PageAccessResponse } from "@/lib/access-utils"

type LockHandlers = { removeHash: () => void; goToAuth: () => void }

// Callers own routing, which keeps this out of the graph `v-link` eagerly loads.
export const openLockAffordance = (
  access: PageAccessResponse,
  { removeHash, goToAuth }: LockHandlers
): void => {
  if (access.granted) return

  if (access.reason === REASONS.REQUIRE_PURCHASE) {
    removeHash()
    EventBus.$emit(EVENTS.TRIGGER_CHECKOUT, {
      productIds: access.data.product_ids,
      overlay: access.data.purchase_overlay
    })
  } else if (access.reason === REASONS.IS_SCHEDULED) {
    if (!("data" in access)) return

    removeHash()
    EventBus.$emit(EVENTS.TRIGGER_SCHEDULED_MODAL, access.data.available_after)
  } else if (access.reason === REASONS.REQUIRE_AUTHENTICATION) {
    goToAuth()
  }
}
